var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar-nav-icon',{attrs:{"v-show":_vm.isLoggedIn},on:{"click":_vm.toggleDrawer}})}
var staticRenderFns = []

export { render, staticRenderFns }